import PropTypes from 'prop-types';
import Button from './Button';

export default function Infobox({ getLabel, resetAllFilters }) {
	return (
		<div className="jobs__infobox">
			<div className="infobox infobox--info-primary">
				<p>{getLabel('no_results')}</p>
				<Button label={getLabel('btn_all_jobs')} onClick={resetAllFilters} primary />
			</div>
		</div>
	);
}

Infobox.propTypes = {
	getLabel: PropTypes.func.isRequired,
	resetAllFilters: PropTypes.func.isRequired,
};
